import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Custom Components
import Footer from './components/Footer';
import Header from './components/Header';
import DTCHeader from './components/DTCHeader';
import CorpHeader from './components/CorpHeader';
import ConsumerHeader from './components/ConsumerHeader';
import PartnerHeader from './components/PartnerHeader';

// Pages
import Index from './pages/Index';
import Applications from './pages/merchant/Applications';
import ApplicationDetail from './pages/merchant/ApplicationDetail';
import ApplicationDetailApproved from './pages/merchant/ApplicationDetailApproved';
import Brochures from './pages/merchant/Brochures';
import Dashboard from './pages/merchant/Dashboard';
import IncomeVerification from './pages/merchant/IncomeVerification';
import Profile from './pages/merchant/Profile';
import ResourceCenter from './pages/merchant/resource-center/ResourceCenter';
import SelectOffer from './pages/merchant/SelectOffer';
import SignIn from './pages/merchant/SignIn';
import TextToApply from './pages/merchant/TextToApply';

import DTCApply from './pages/dtc/Apply';
import DTCAutoPay from './pages/dtc/AutoPay';
import DTCComplete from './pages/dtc/Complete';
import DTCDeclined from './pages/dtc/Declined';
import DTCDeclinedOffer from './pages/dtc/DeclinedOffer';
import DTCDeclinedOfferAFF from './pages/dtc/DeclinedOfferAFF';
import DTCFindMerchant from './pages/dtc/FindMerchant';
import DTCLoanOffer from './pages/dtc/LoanOffer';
import DTCPreApproved from './pages/dtc/PreApproved';
import DTC2faMain from './pages/dtc/2fa/Main';
import DTCRepromptIDUpload from './pages/dtc/reprompt/IDUpload';
import DTCRepromptLastName from './pages/dtc/reprompt/LastName';
import DTCRepromptSSN from './pages/dtc/reprompt/SSN';
import DTCRepromptTextLink from './pages/dtc/reprompt/TextLink';
import DTCSignLoan from './pages/dtc/SignLoan';

import PersonifyDeclineStart from './pages/personify/DeclineStart';
import PersonifyConsent from './pages/personify/Consent';
import PersonifyIncome from './pages/personify/Income';
import PersonifyApproved from './pages/personify/Approved';
import PersonifySelectOffer from './pages/personify/SelectOffer';
import PersonifyACH from './pages/personify/ACH';
import PersonifyConfirm from './pages/personify/Confirm';
import PersonifySecurity from './pages/personify/Security';
import PersonifySecurityKBA from './pages/personify/SecurityKBA';
import PersonifySignaturePending from './pages/personify/SignaturePending';
import PersonifySignAgreement from './pages/personify/SignAgreement';
import PersonifyDecline from './pages/personify/Decline';

import CorpDashboard from './pages/corporate/Dashboard';
import CorpMerchants from './pages/corporate/Merchants';
import CorpMerchantDetail from './pages/corporate/MerchantDetail';
import CorpRefunds from './pages/corporate/Refunds';
import CorpApplications from './pages/corporate/Applications';

import ConsumerSignIn from './pages/consumer/SignIn';
import ConsumerCreateAccount from './pages/consumer/CreateAccount';
import ConsumerForgotPassword from './pages/consumer/ForgotPassword';
import ConsumerDashboard from './pages/consumer/Dashboard';
import ConsumerMyLoans from './pages/consumer/MyLoans';
import ConsumerDocuments from './pages/consumer/Documents';
import ConsumerSettings from './pages/consumer/settings/Settings';

import './App.scss';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout>
      <Component {...props} />
    </Layout>
  )} />
)

const DefaultLayout = props => (
  <div className="App bg-light">
    <Header />
    <div className="container-body">
      {props.children}
    </div>
    <Footer />
    <ToastContainer position="top-center" />
  </div>
)

const AuthLayout = props => (
  <div className="App bg-light d-flex align-items-center">
    <div className="container-body w-100">
      {props.children}
    </div>
    <ToastContainer position="top-center" />
  </div>
)

const DTCLayout = props => (
  <div className="App bg-white">
    <DTCHeader />
    <div className="container-body">
      {props.children}
    </div>
    <Footer />
    <ToastContainer position="top-center" />
  </div>
)

const PartnerLayout = props => (
  <div className="App bg-light">
    <PartnerHeader />
    <div className="container-body">
      {props.children}
    </div>
    <ToastContainer position="top-center" />
  </div>
)

const CorpLayout = props => (
  <div className="App bg-light">
    <CorpHeader />
    <div className="container-body corporate">
      {props.children}
    </div>
    <Footer />
    <ToastContainer position="top-center" />
  </div>
)

const ConsumerLayout = props => (
  <div className="App bg-light">
    <ConsumerHeader />
    <div className="container-body consumer">
      {props.children}
    </div>
    <Footer />
    <ToastContainer position="top-center" />
  </div>
)

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <AppRoute layout={AuthLayout} path="/sign-in" component={SignIn} />

          <AppRoute layout={DefaultLayout} exact path="/" component={Index} />
          <AppRoute layout={DefaultLayout} path="/dashboard" component={Dashboard} />
          <AppRoute layout={DefaultLayout} path="/applications" component={Applications} />
          <AppRoute layout={DefaultLayout} path="/application/detail" exact component={ApplicationDetail} />
          <AppRoute layout={DefaultLayout} path="/application/detail/approved" component={ApplicationDetailApproved} />
          <AppRoute layout={DefaultLayout} path="/application/select-offer" component={SelectOffer} />
          <AppRoute layout={DefaultLayout} path="/application/income-verification" component={IncomeVerification} />
          <AppRoute layout={DefaultLayout} path="/profile" component={Profile} />
          <AppRoute layout={DefaultLayout} path="/resource-center" component={ResourceCenter} />
          <AppRoute layout={DefaultLayout} path="/brochures" component={Brochures} />
          <AppRoute layout={DefaultLayout} path="/text-to-apply" component={TextToApply} />

          <AppRoute layout={DTCLayout} path="/dtc/apply" component={DTCApply} />
          <AppRoute layout={DTCLayout} path="/dtc/merchant" component={DTCFindMerchant} />
          <AppRoute layout={DTCLayout} path="/dtc/approved" component={DTCPreApproved} />
          <AppRoute layout={DTCLayout} path="/dtc/declined" component={DTCDeclined} />
          <AppRoute layout={DTCLayout} path="/dtc/declined-offer" component={DTCDeclinedOffer} />
          <AppRoute layout={DefaultLayout} path="/dtc/declined-offer-aff" component={DTCDeclinedOfferAFF} />
          <AppRoute layout={DTCLayout} path="/dtc/loan-offer" component={DTCLoanOffer} />
          <AppRoute layout={DTCLayout} path="/dtc/autopay" component={DTCAutoPay} />
          <AppRoute layout={DTCLayout} path="/dtc/sign" component={DTCSignLoan} />
          <AppRoute layout={DTCLayout} path="/dtc/complete" component={DTCComplete} />
          <AppRoute layout={DTCLayout} path="/dtc/2fa" component={DTC2faMain} />
          <AppRoute layout={DTCLayout} path="/dtc/verify/lastname" component={DTCRepromptLastName} />
          <AppRoute layout={DTCLayout} path="/dtc/verify/ssn" component={DTCRepromptSSN} />
          <AppRoute layout={DTCLayout} path="/dtc/verify/text-link" component={DTCRepromptTextLink} />
          <AppRoute layout={DTCLayout} path="/dtc/verify/id-upload" component={DTCRepromptIDUpload} />

          <AppRoute layout={DefaultLayout} path="/personify/decline-start" component={PersonifyDeclineStart} />
          <AppRoute layout={PartnerLayout} path="/personify/consent" component={PersonifyConsent} />
          <AppRoute layout={PartnerLayout} path="/personify/income" component={PersonifyIncome} />
          <AppRoute layout={PartnerLayout} path="/personify/approved" component={PersonifyApproved} />
          <AppRoute layout={PartnerLayout} path="/personify/select-offer" component={PersonifySelectOffer} />
          <AppRoute layout={PartnerLayout} path="/personify/ach" component={PersonifyACH} />
          <AppRoute layout={PartnerLayout} path="/personify/confirm" component={PersonifyConfirm} />
          <AppRoute layout={PartnerLayout} path="/personify/security" component={PersonifySecurity} />
          <AppRoute layout={PartnerLayout} path="/personify/kba" component={PersonifySecurityKBA} />
          <AppRoute layout={PartnerLayout} path="/personify/pending" component={PersonifySignaturePending} />
          <AppRoute layout={PartnerLayout} path="/personify/sign" component={PersonifySignAgreement} />
          <AppRoute layout={PartnerLayout} path="/personify/decline" component={PersonifyDecline} />

          <AppRoute layout={CorpLayout} path="/corp/dashboard" component={CorpDashboard} />
          <AppRoute layout={CorpLayout} path="/corp/merchants" component={CorpMerchants} />
          <AppRoute layout={CorpLayout} path="/corp/merchant-detail" component={CorpMerchantDetail} />
          <AppRoute layout={CorpLayout} path="/corp/merchant-refunds" component={CorpRefunds} />
          <AppRoute layout={CorpLayout} path="/corp/applications" component={CorpApplications} />

          <AppRoute layout={AuthLayout} path="/consumer/signin" component={ConsumerSignIn} />
          <AppRoute layout={AuthLayout} path="/consumer/create-account" component={ConsumerCreateAccount} />
          <AppRoute layout={AuthLayout} path="/consumer/forgot-password" component={ConsumerForgotPassword} />
          <AppRoute layout={ConsumerLayout} path="/consumer/dashboard" component={ConsumerDashboard} />
          <AppRoute layout={ConsumerLayout} path="/consumer/loans" component={ConsumerMyLoans} />
          <AppRoute layout={ConsumerLayout} path="/consumer/documents" component={ConsumerDocuments} />
          <AppRoute layout={ConsumerLayout} path="/consumer/settings" component={ConsumerSettings} />
        </div>
      </Router>
    );
  }
}

export default App;
